var _rect, _circle, _path, _circle2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvitePress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 38,
    height: 38,
    rx: 4,
    fill: "#12121F",
    stroke: "#EDEBF5",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 22,
    r: 5,
    fill: "#EDEBF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2212 31.9572C16.3111 29.8479 18.0635 28.1365 20.203 27.0981C21.4559 28.2774 23.1434 29 24.9998 29C26.8561 29 28.5437 28.2774 29.7965 27.0981C31.9361 28.1365 33.6884 29.8479 34.7783 31.9572C32.6028 35.0095 29.0337 37 24.9998 37C20.9658 37 17.3968 35.0095 15.2212 31.9572Z",
    fill: "#EDEBF5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 15.5,
    stroke: "#EDEBF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 22L35 28",
    stroke: "#EDEBF5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25L38 25",
    stroke: "#EDEBF5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitePress);
export default __webpack_public_path__ + "static/media/invite-press.a4bb3d389a75be4dcf5395427100ed54.svg";
export { ForwardRef as ReactComponent };